'use client';
import * as e from 'react';
import { SwanFonts } from './fonts.component.js';
import { SwanPageMeta } from './page-meta.component.js';
import { SwanStylesheets } from './stylesheets.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const SwanHead = (n)=>{
    var { fontNames: c, styleSheetKeys: l, renderStyleContentAsChildren: p } = n, i = _object_without_properties(n, [
        "fontNames",
        "styleSheetKeys",
        "renderStyleContentAsChildren"
    ]);
    return e.createElement(e.Fragment, null, e.createElement(SwanPageMeta, i), e.createElement(SwanFonts, _object_spread({
        fontNames: c,
        renderStyleContentAsChildren: p
    }, i)), e.createElement(SwanStylesheets, _object_spread({
        styleSheetKeys: l
    }, i)));
};

export { SwanHead };
